import { useState, useEffect } from 'react';
import { portalAgreementAPI } from '../services/agreementAPI';

interface AgreementGateState {
  loading: boolean;
  accepted: boolean;
  currentVersion: string | null;
}

export function useAgreementGate() {
  const [state, setState] = useState<AgreementGateState>({
    loading: true,
    accepted: true, // fail open
    currentVersion: null,
  });

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const data = await portalAgreementAPI.getPlatformStatus();
        if (!cancelled) {
          setState({
            loading: false,
            accepted: data.accepted,
            currentVersion: data.current_version,
          });
        }
      } catch {
        // Fail open: if API errors, don't block user
        if (!cancelled) {
          setState({ loading: false, accepted: true, currentVersion: null });
        }
      }
    };

    check();
    return () => { cancelled = true; };
  }, []);

  const markAccepted = () => {
    setState(prev => ({ ...prev, accepted: true }));
  };

  return { ...state, markAccepted };
}
